import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translations from './translations.json';

// Get saved language from localStorage, default to 'en' if not set
const getSavedLanguage = () => {
  const saved = localStorage.getItem('comparevin_language');
  if (saved && ['en', 'fr', 'es', 'de'].includes(saved)) {
    return saved;
  }
  return 'en'; // Always default to English, never browser language
};

i18n
  .use(initReactI18next)
  .init({
    resources: translations,
    lng: getSavedLanguage(), // Use saved language
    fallbackLng: 'en',
    supportedLngs: ['en', 'fr', 'es', 'de'],
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

// Save language to localStorage whenever it changes
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('comparevin_language', lng);
});

export default i18n;
